import { action, makeObservable, observable } from "mobx";
import _ from "lodash";
import html from "csi/html";
import { localStore } from "csi/state/rootStore";
import { RightPaneComponent } from "csi/state/rightPane";
import { isAllowedForTypeFunc, INGREDIENT_CONTRIBUTOR } from "csi/service/rightPaneService";
import { C8Node, cnl, ICache } from "csi/typings";

const DEFAULT_WIDTH: number = 372;
class IngredientContributorPaneComponent extends RightPaneComponent {
	@observable private _ingredientItemURL: cnl;
	@observable private _foodIngredientURL: cnl;

	cache: ICache;

	/** selected ingredient item url */
	get ingredientItemUrl(): cnl {
		return this._ingredientItemURL;
	}

	/** selected ingredient item */
	get ingredientItem(): C8Node {
		return this.cache?.get(this._ingredientItemURL);
	}

	/** food ingredient name */
	get foodIngredient(): C8Node {
		return this.cache?.get(this._foodIngredientURL);
	}

	/** set selected task */
	@action setIngredientItemURL(ingredientItemURL: cnl): void {
		this._ingredientItemURL = ingredientItemURL;
	}

	/** set food ingredient */
	@action setFoodIngredientURL(foodIngredientURL: cnl): void {
		this._foodIngredientURL = foodIngredientURL;
	}

	/** sets the cache */
	@action setCache(cache: ICache): void {
		this.cache = cache;
	}

	constructor() {
		const allowedTypes: string[] = ["FoodBOM", "RecipeDataSheet"];

		super(INGREDIENT_CONTRIBUTOR, {
			getResizeWidth: (): number => { return localStore.right.width; },
			isAllowed: isAllowedForTypeFunc(allowedTypes),
			resizable: true,
			setResizeWidth: (w: number): void => { localStore.right.width = w; },
			view: "FormulatedProduct/FoodLabel/IngredientContributorPane",
			viewWidth: DEFAULT_WIDTH + html.getVerticalScrollbarWidth(),
		});

		makeObservable(this);

		localStore.right.width = DEFAULT_WIDTH * 2 + html.getVerticalScrollbarWidth();
	}
}

export = IngredientContributorPaneComponent;
